import { CustomPropertiesKeys } from '@/common/composables/usePageData'

/** Серверный Element.openSuggester() → state custom_properties open_suggester. */
export function collectOpenSuggesterElementNames(states: unknown): string[] {
  if (!Array.isArray(states) || states.length === 0) return []

  const names: string[] = []
  for (const raw of states) {
    if (raw == null || typeof raw !== 'object') continue
    const state = raw as Record<string, unknown>
    const elementName = String(state.element_name ?? '').trim()
    if (!elementName) continue

    const props = state.custom_properties
    if (!Array.isArray(props)) continue

    for (const prop of props) {
      if (prop == null || typeof prop !== 'object') continue
      const propertyName = String((prop as { property_name?: unknown }).property_name ?? '').trim()
      if (propertyName !== CustomPropertiesKeys.OPEN_SUGGESTER) continue
      names.push(elementName)
      break
    }
  }
  return names
}

export function applyOpenSuggesterFromStates(
  states: unknown,
  openSuggesterElement: (elementName: string, registryFormId?: string) => void,
  registryFormId?: string,
): void {
  for (const elementName of collectOpenSuggesterElementNames(states)) {
    openSuggesterElement(elementName, registryFormId)
  }
}
